// extracted by mini-css-extract-plugin
export default {"companyRow":"CompanyBlock_companyRow__kOj2v","name":"CompanyBlock_name__I9Xla","logo":"CompanyBlock_logo__zY9yG"};